import { useState, FC } from "react";
import { v4 as uuidv4 } from 'uuid';
import { LabelDesignerTemplateGridPluginSettings } from "./LabelDesignerTemplateGridPluginSettings";
import { GridSelectorModalWindow } from "../../../components/modalWindows/GridSelectorModalWindow";
import { IEntitySimpleDTO } from "../../../libs/coreapi-dto/@types/common";
import { LabelDesignerTemplateGrid } from "./LabelDesignerTemplateGrid";

export const LabelDesignerTemplateSelectorModal: FC<IGridSelectorModalProps> = (props) => {
    const [entity, setEntity] = useState<IEntitySimpleDTO>(props.selectedEntity ?? {} as IEntitySimpleDTO)
    const [entities, setEntities] = useState<IEntitySimpleDTO[]>(props?.selectedEntities ?? []);

    return (
        <GridSelectorModalWindow
            entityToPressEnter={entity}
            gridDisplayName={LabelDesignerTemplateGridPluginSettings.name}
            ok={{
                onClick: () => props.multipleSelect ? props.ok(entities) : props.ok?.(entity)
            }}
            cancel={{ onClick: () => props.cancel?.() }}
        >
            {
                LabelDesignerTemplateGridPluginSettings ? (
                    <LabelDesignerTemplateGrid
                        data={entities}
                        gridId={uuidv4()}
                        plugin={LabelDesignerTemplateGridPluginSettings}
                        onSelect={(row) => {
                            if (row) {

                            }
                            row && setEntity({ idGlobal: row.idGlobal, displayName: row.displayName })
                        }}
                        onDoubleClick={(row) => {
                            setEntity({ idGlobal: row.idGlobal, displayName: row.displayName })
                            props.ok?.(entity)
                        }}
                        multipleSelect={props.multipleSelect}
                        onMultipleSelect={(rows) => {
                            rows && setEntities(rows.map(x => ({ idGlobal: x.idGlobal, displayName: x.displayName } as IEntitySimpleDTO)))
                        }}
                    />
                ) : (
                    <p> Справочник не настроен </p>
                )
            }
        </GridSelectorModalWindow>
    )
}